/* eslint-disable no-unused-vars */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import {
  Grid,
  VirtualizedCell,
  defaultVirtualizedCellRender,
  extractAndFormatData,
  virtualizedGridRenderer,
  freeEditEngine,
} from '@integec/grid-tools'
import {
  Button,
  Checkbox,
  DatePicker,
  Divider,
  Input,
  Popconfirm,
  Select,
  Tooltip,
  message,
  Modal,
  InputNumber,
  Tabs,
} from 'antd'
import {
  createSolarInvPerormanceWithInvEvents,
  getSolarAvailabilityStatus,
  getSolarCauseCode,
  getSolarContribCondtition,
  getSolarInvPerormanceWithInvEvents,
  getSolarInverterIdByPlantId,
  getSystemConfigurationInfo,
  operationSolarInvPerormanceWithInvEventsDelete,
  solarEventDelete,
  solarEventDeleteInverter,
  solarImpactAnalysis,
  solarPlantWithInverterGroup,
  // solarProcessCreateEventData,
  solarProcessEventAndPerformanceData,
  solarEventUpdateInverter,
  solarEventUpdate,
  solarPerformanceUpdate,
  operationSolarInvPerormanceWithInvEvents,
  // solarProcessPerformanceData,
  getSolarInverterGroup,
  solarPlantSelection,
} from 'api/pgads'
import {
  DataContext,
  ErrorContext,
  JcTmpErrorContext,
  SpinContext,
} from 'context'
import { ExportComponent, getApiTargetInfo } from 'core'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Label,
  Title,
} from 'core/screen-util'
import React, {
  useEffect,
  useState,
  useContext,
  useMemo,
  useCallback,
  useRef,
} from 'react'
import { connect } from 'react-redux'
import {
  SolarInverterEventIoHeaders,
  SolarInverterPerformanceHeaders,
  SolarNercEventIoHeaders,
  SolarPerformanceIoHeaders,
} from './Headers'
import {
  rowHeaderRender,
  hasAccesPermits,
  exportDataComponent,
} from 'core/utils'
import SolarEventDialog, { saveDateformat } from './SolarEventDialog'
import R from 'ramda'
import SolarInverterEventDialog from './SolarInverterEventDialog'
import JcTmpErrorDialog, {
  isErrorContains,
} from 'core/component/JcTmpErrorDialog'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import { getTimeZone } from 'wind2/wind2utils'
import SolarInverterPerformanceDialog from './SolarInverterPerformanceDialog'
import SolarInverterValidationDialog from './SolarInverterValidationDialog'
import { Icon } from 'antd/lib'
import moment from 'moment'
import ImpactAnalysis from './impactanalysis/ImpactAnalysis'
import SolarPerformanceDialog from './SolarPerformanceDialog'
import {
  exportSolarInverterData,
  getSolarEventTypes,
  updateMultipleCaucecodeInverterEvent,
} from './solarapi'
import {
  dateTimeCol,
  numCol,
  strCol,
  intCol,
} from '@integec/grid-tools/lib/cols'
import { toXlsxColumns, toXlsxData, writeToExcel } from 'marginanalysis/Headers'
import { saveAs } from 'file-saver'
import {
  SOLAR_ADMIN_POWER_DATA,
  SOLAR_UPDATE_CAUCECODE_INVERTEREVENT,
} from '../core/EventActions'
import { getEnvConfig, getPermitActions } from '../core/selectors'
import MultiCauseCode from 'card-data/MultiCauseCode'
import { getValidPlantList } from './util'
import FilterContext, {
  effectvieFilterCount,
  emptyFilterObj,
  getGridPropsObj,
} from '../context/FilterContext'

const SolarInverterPerformacePowerData = ({ targetInfo, actionPermits }) => {
  const [plantSelectionData, setPlantSelectionData] = useState([])
  const {
    selectedSolarPlant,
    setSelectedSolarPlant: setPlantSelected,
  } = useContext(DataContext)
  const plantSelected = Array.isArray(selectedSolarPlant)
    ? selectedSolarPlant[0]
    : selectedSolarPlant

  const [performanceData, setPerformanceData] = useState([])
  const [inverterEventData, setInverterEventData] = useState([])
  const [eventData, setEventData] = useState([])
  const [nercPerformanceData, setNercPerformanceData] = useState([])
  //   p = per , e = inv event , n=nerc event,np nercPerf
  const [isPerformacneSelected, setIsPerformacneSelected] = useState('P')

  const inverterPerformanceGridRef = useRef()
  const nercPerformanceGridRef = useRef()
  const inverterEventGridRef = useRef()
  const nercEventGridRef = useRef()

  const {
    setGridProps,
    setDrawerVisible,
    setFilterCondition,
    filterCondition,
  } = useContext(FilterContext)

  const [origData, setOrigData] = useState({ P: [], E: [], N: {}, NP: [] })

  const [performanceRowSelected, setPerformanceRowSelected] = useState([])
  const [nercPerformanceRowSelected, setNercPerformanceRowSelected] = useState(
    []
  )
  const [inverterSelected, setInverterSelected] = useState([])

  const [selectedDate, setSelectedDate] = useState(
    moment()
      .subtract(1, 'months')
      .endOf('month')
  )
  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const { setTmpError } = useContext(JcTmpErrorContext)

  const [isRetrived, setIsRetrieved] = useState(false)
  const [showPerformanceDialog, setPerformanceDialog] = useState({})
  const [showNercPerformanceDialog, setNercPerformanceDialog] = useState({})
  const [showInverterEventDialog, setInverterEventDialog] = useState({})
  const [showValidationDialog, setShowValidationDialog] = useState({})
  const [fuzzyFilter, setFuzzyFilter] = useState('')

  const [contribConditionList, setContribConditionList] = useState([])

  const [causecodeList, setCausecodeList] = useState([])
  const [inverterIdBYPlant, setInverterIdByPlant] = useState([])
  const [availableStatus, setAvailableStatus] = useState([])

  // eslint-disable-next-line no-unused-vars
  const [checkedValues, setCheckedValues] = useState(['E', 'P'])

  const [eventSelected, setEventSelected] = useState([])
  const [showEventDialog, setEventDialog] = useState({})
  const [showRecalcCheckbox, setShowRecalcCheckbox] = useState(true)

  // eslint-disable-next-line no-unused-vars
  const [impactAnalysisDialog, setImpactAnalysisDialog] = useState(false)
  const [impactAnalysisData, setImpactAnalysisData] = useState({})
  const [recalcInverterperf, setRecalcInverterPerf] = useState('N')

  const [runInfoStatus, setRunInfoStatus] = useState({
    isModificationExits: false,
  })

  const [importResult, setImportResult] = useState({
    jcTmpErrors: [],
    data: [],
  })
  const [editInfo, setEditInfo] = useState(
    freeEditEngine.generateInitialEditInfo()
  )

  const hasSolarPowerDataWritePermission = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits: actionPermits,
        eventActions: [SOLAR_ADMIN_POWER_DATA],
        matchAny: true,
      }),
    [actionPermits]
  )

  const [eventTypes, setEventTypes] = useState([])
  useEffect(
    _ => {
      getSolarContribCondtition(targetInfo).fork(
        _ => _,
        setContribConditionList
      )
      getSolarEventTypes(targetInfo).fork(_ => _, setEventTypes)
      getSolarAvailabilityStatus(targetInfo).fork(_ => _, setAvailableStatus)
      getSolarCauseCode(targetInfo).fork(
        _ => _,
        data => {
          const matchToSelct = data.map(
            ({ system, subsystem, causecode, description }) => ({
              system,
              component: subsystem,
              causeCode: causecode,
              description,
              unitCode: 'SO',
              unitType: 'SO',
              isOMC: false,
            })
          )
          setCausecodeList(matchToSelct)
        }
      )
      getSolarInverterGroup(targetInfo).fork(setError, setInverterGroupList)
    },
    [setError, targetInfo]
  )
  const [plantList, setPlantList] = useState([])
  const [inverterGroupList, setInverterGroupList] = useState([])

  useEffect(
    _ => {
      // make sort plantName
      // solarPlantWithInverterGroup(targetInfo).fork(setError, data => {
      //   const sd = R.sortBy(R.prop('plantName'), data)
      //   setPlantSelectionData(sd)
      //   if (!plantSelected && sd[0] && sd[0].plantId)
      //     setPlantSelected(sd[0].plantId)
      // })
      solarPlantSelection(targetInfo)({
        year: selectedDate.format('YYYY'),
        month: selectedDate.format('MM'),
      }).fork(setError, data => {
        setPlantList(data)
      })
    },
    [targetInfo, selectedDate, setError, plantSelected]
  )

  useEffect(
    _ => {
      let stoList = []

      stoList = getValidPlantList(plantList, inverterGroupList, [])
      setPlantSelectionData(stoList)

      const isValidSelection = stoList.some(p => p.plantId === plantSelected)
      if (!isValidSelection && stoList[0] && stoList[0].plantId) {
        if (plantSelected !== stoList[0].plantId) {
          setPlantSelected([stoList[0].plantId])
        }
      }
    },
    [inverterGroupList, plantList, plantSelected, setPlantSelected]
  )

  useEffect(
    _ => {
      if (plantSelected)
        getSolarInverterIdByPlantId(targetInfo)(plantSelected).fork(
          setError,
          setInverterIdByPlant
        )
    },
    [plantSelected, setError, targetInfo]
  )

  const clearData = _ => {
    setNercPerformanceData([])
    setPerformanceData([])
    setIsRetrieved(false)
    setInverterEventData([])
    setRunInfoStatus({ isModificationExits: false })
    setEventSelected([])
    setImpactAnalysisDialog(false)
    setImpactAnalysisData({})
    setEventData([])
    setOrigData({ P: [], E: [], N: [], NP: [] })
    setFilterCondition([{}])
  }

  const retrieveData = (dataChanged, cdate = selectedDate) => {
    if (dataChanged && editInfo.updated.length > 0) {
      setShowValidationDialog({
        visible: true,
        //  value: value, // passing the value to the modal
        onYes: updateData, // function to call when "Yes" is clicked
        onNo: retrieveData, // correctly passing value to onNo handler
      })
    } else {
      if (!plantSelected) {
        message.info('Please, Select Plant')
        return
      }
      setSpinning(true)
      getSolarInvPerormanceWithInvEvents(targetInfo)({
        year: cdate.format('YYYY'),
        month: cdate.format('MM'),
        plantid: plantSelected,
      }).fork(setError, data => {
        setSpinning(false)
        setFilterCondition([{}])
        setIsRetrieved(true)

        setInverterEventData(data.inverterEvents)
        setEventData(data.eventData)

        const {
          inverterPerformance,
          lastModifiedDate,
          lastRunTime,
          isModificationExits,
          lastModifiedDateInverter,
          lastRunTimeInverter,
          isModificationExitsInverter,
          nercPerformance,
        } = data
        setRunInfoStatus({
          lastModifiedDate,
          lastRunTime,
          isModificationExits,
          lastModifiedDateInverter,
          lastRunTimeInverter,
          isModificationExitsInverter,
        })

        const inverterPerformanceData = R.sortBy((a, b) => {
          if ((a.inverterGroupName || '') === 'TOTAL') return 100000
          else {
            return R.toLower((a && a.inverterGroupName) || '').localeCompare(
              R.toLower((b && b.inverterGroupName) || '')
            )
          }
        }, inverterPerformance)

        setPerformanceData(inverterPerformanceData)
        setTmpError(data.level2ValidationError)
        const nercPerformanceData = R.compose(
          R.sortBy((a, b) => {
            if ((a.inverterGroupName || '') === 'TOTAL') return 100000
            else {
              return R.toLower((a && a.inverterGroupId) || '').localeCompare(
                R.toLower((b && b.inverterGroupId) || '')
              )
            }
          })
          // R.filter(f => f.inverterGroupName !== 'TOTAL')
        )(nercPerformance)

        setNercPerformanceData(nercPerformanceData)

        setOrigData({
          P: inverterPerformanceData,
          E: data.inverterEvents,
          N: data.eventData,
          NP: nercPerformanceData,
        })
      })
    }
  }

  const SolarInverterEventHeaders = useCallback(
    (width, withPlantIdHeader = false) =>
      SolarInverterEventIoHeaders(
        width,
        contribConditionList,
        eventTypes,
        inverterIdBYPlant,
        withPlantIdHeader
      ),
    [contribConditionList, eventTypes, inverterIdBYPlant]
  )

  const deleteInverterEvent = _ => {
    setSpinning(true)
    solarEventDeleteInverter(targetInfo)(inverterSelected).fork(
      setError,
      errorList => {
        setSpinning(false)
        setTmpError(errorList)
        if (!isErrorContains(errorList)) {
          message.info('Data saved.')
          retrieveData()
        }
      }
    )
  }

  const PerformanceHeaderFormaterFunc = useCallback(
    (withPlantIdHeader = false) => {
      return SolarInverterPerformanceHeaders(
        inverterIdBYPlant,
        withPlantIdHeader
      ).map(d => {
        if (d.ident === 'inverterAvailability') {
          const statusMap = R.compose(
            R.fromPairs,
            R.map(d => [d.availabilityStatusCode, d.availabilityStatusName])
          )(availableStatus)
          return { ...d, ...toSelectionColProps(statusMap) }
        }
        return d
      })
    },
    [availableStatus, inverterIdBYPlant]
  )

  const PerformanceHeaderFormater = useMemo(
    _ => PerformanceHeaderFormaterFunc(false),
    [PerformanceHeaderFormaterFunc]
  )
  const PerformanceHeaderFormaterwithPlantId = useMemo(
    _ => PerformanceHeaderFormaterFunc(true),
    [PerformanceHeaderFormaterFunc]
  )

  const NercPerformanceHeaderFormaterFunc = useCallback(
    (withPlantIdHeader = false) => {
      return SolarPerformanceIoHeaders(
        inverterGroupList,
        withPlantIdHeader
      ).map(d => {
        if (d.ident === 'invGroupAvailability') {
          const statusMap = R.compose(
            R.fromPairs,
            R.map(d => [d.availabilityStatusCode, d.availabilityStatusName])
          )(availableStatus)
          return { ...d, ...toSelectionColProps(statusMap) }
        }
        return d
      })
    },
    [availableStatus, inverterGroupList]
  )

  const NercPerformanceHeaderFormater = useMemo(
    _ => NercPerformanceHeaderFormaterFunc(false),
    [NercPerformanceHeaderFormaterFunc]
  )
  const NercPerformanceHeaderFormaterWithPlantId = useMemo(
    _ => NercPerformanceHeaderFormaterFunc(true),
    [NercPerformanceHeaderFormaterFunc]
  )

  const EventHeader = useCallback(
    (width, withPlantIdHeader = false) =>
      SolarNercEventIoHeaders(
        width,
        contribConditionList,
        eventTypes,
        withPlantIdHeader
      ),
    [contribConditionList, eventTypes]
  )

  const mapIsPerformacneSelected = {
    P: {
      data: performanceData,
      setData: setPerformanceData,
      updateApi: operationSolarInvPerormanceWithInvEvents,
      header: PerformanceHeaderFormater,
      exportHeader: PerformanceHeaderFormaterwithPlantId,
      ref: inverterPerformanceGridRef,
      title: 'Inverter Performance',
    },
    NP: {
      data: nercPerformanceData,
      setData: setNercPerformanceData,
      updateApi: solarPerformanceUpdate,
      header: NercPerformanceHeaderFormater,
      exportHeader: NercPerformanceHeaderFormaterWithPlantId,
      ref: nercPerformanceGridRef,
      title: 'NERC Performance',
    },
    N: {
      data: eventData,
      setData: setEventData,
      updateApi: solarEventUpdate,
      header: EventHeader(30),
      exportHeader: EventHeader(30, true),
      ref: nercEventGridRef,
      title: 'NERC Event',
    },
    E: {
      data: inverterEventData,
      setData: setInverterEventData,
      updateApi: solarEventUpdateInverter,
      header: SolarInverterEventHeaders(30),
      exportHeader: SolarInverterEventHeaders(30, true),
      ref: inverterEventGridRef,
      title: 'Inverter Event',
    },
  }

  const isPlantLocked = useMemo(
    _ => {
      const total = (nercPerformanceData || []).find(
        s => s.inverterGroupName === 'TOTAL'
      ) || { action: 'U' }
      return total.action === 'L' || total.action === 'l'
    },
    [nercPerformanceData]
  )

  const getplantIdandEntityId = _ => {
    const sel = plantSelectionData.find(f => f.plantId === plantSelected)
    return {
      entityId: sel.entityId,
      plantId: sel.plantId,
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
    }
  }

  const insertPerformanceCall = _ => {
    setPerformanceDialog({
      isNew: true,
      visible: true,
      data: { ...getplantIdandEntityId() },
    })
  }

  const updatePerformanceCall = _ => {
    if (performanceRowSelected?.length > 1) {
      message.info('Please, Select only one row')
      return
    }
    const isTtoal =
      performanceRowSelected[0] &&
      (performanceRowSelected[0].subgroupName === 'TOTAL' ||
        performanceRowSelected[0].inverterGroupName === 'TOTAL')

    if (!isTtoal && !R.isNil(isTtoal) && !isPlantLocked)
      setPerformanceDialog({
        isNew: false,
        visible: true,
        data: performanceRowSelected[0],
      })
  }

  const updateNercPerformanceCall = _ => {
    const isTtoal =
      nercPerformanceRowSelected[0] &&
      (nercPerformanceRowSelected[0].subgroupName === 'TOTAL' ||
        nercPerformanceRowSelected[0].inverterGroupName === 'TOTAL')

    if (!isTtoal && !R.isNil(isTtoal) && !isPlantLocked)
      setNercPerformanceDialog({
        isNew: false,
        visible: true,
        data: nercPerformanceRowSelected[0],
      })
  }

  const deletePerformacneCall = _ => {
    setSpinning(true)
    operationSolarInvPerormanceWithInvEventsDelete(targetInfo)(
      performanceRowSelected
    ).fork(setError, tmpError => {
      setSpinning(false)
      setTmpError(tmpError)
      retrieveData()
    })
  }

  const performanceDoubleClick = props => {
    const { gridToolProps, reactVirtualizedProps } = props

    const { getCellProps, headers, data } = gridToolProps

    const { columnIndex, rowIndex, style } = reactVirtualizedProps
    const type = gridToolProps.headers[reactVirtualizedProps.columnIndex].type

    if (headers[columnIndex].ident === 'inverterId') {
      let modifierProps = getCellProps({
        rowIndex,
        columnIndex,
        header: headers.find(h => h.ident === 'inverterId') || {},
        data,
        style,
      })
      const cellData = extractAndFormatData({
        rowData: data[rowIndex],
        header: headers[columnIndex],
      })
      // const modifiercellData = extractAndFormatData({
      //   rowData: data[rowIndex],
      //   header: headers.find(h=>h.ident==='modifier'),
      // })
      const modifiercellData = (data[rowIndex].modificationInfo || { user: '' })
        .user

      const isSystemUser = R.toLower(modifiercellData || '').includes('system')

      const backgroundColor = isSystemUser ? '#c5e0b4' : '#ffff00'
      const color = isSystemUser ? 'black' : 'black'
      if (modifiercellData) {
        // eslint-disable-next-line no-unused-vars
        let { style, data, isSelected, ...rest } = modifierProps
        style = {
          ...style,
          backgroundColor,
          color: isSelected ? color : undefined,
        }
        modifierProps = { ...rest, style, isSelected }
      }
      return (
        <VirtualizedCell
          {...R.omit(['data'], modifierProps)}
          // onDoubleClick={_ => {
          //   // onUpdate()
          //   !isPlantLocked && updatePerformanceCall()
          // }}
        >
          {cellData}
        </VirtualizedCell>
      )
    }

    return defaultVirtualizedCellRender({
      ...props,
      style,
      editRender:
        type === 'date' || type === 'date-time' ? dateEditor : undefined,
    })
  }

  const nercPerformanceDoubleClick = props => {
    const { gridToolProps, reactVirtualizedProps } = props

    const { getCellProps, headers, data } = gridToolProps

    const { columnIndex, rowIndex, style } = reactVirtualizedProps

    if (headers[columnIndex].ident === 'inverterGroupName') {
      let modifierProps = getCellProps({
        rowIndex,
        columnIndex,
        header: headers.find(h => h.ident === 'inverterGroupName') || {},
        data,
        style,
      })
      const cellData = extractAndFormatData({
        rowData: data[rowIndex],
        header: headers[columnIndex],
      })
      // const modifiercellData = extractAndFormatData({
      //   rowData: data[rowIndex],
      //   header: headers.find(h=>h.ident==='modifier'),
      // })
      const modifiercellData = (data[rowIndex].modificationInfo || { user: '' })
        .user

      const isSystemUser = R.toLower(modifiercellData || '').includes('system')

      const backgroundColor = isSystemUser ? '#c5e0b4' : '#ffff00'
      const color = isSystemUser ? 'black' : 'black'
      if (modifiercellData) {
        // eslint-disable-next-line no-unused-vars
        let { style, data, isSelected, ...rest } = modifierProps
        style = {
          ...style,
          backgroundColor,
          color: isSelected ? color : undefined,
        }
        modifierProps = { ...rest, style, isSelected }
      }
      return (
        <VirtualizedCell
          {...R.omit(['data'], modifierProps)}
          onDoubleClick={_ => {
            // onUpdate()
            !isPlantLocked && updateNercPerformanceCall()
          }}
        >
          {cellData}
        </VirtualizedCell>
      )
    }

    return defaultVirtualizedCellRender({
      ...props,
      onDoubleClick: _ => {
        !isPlantLocked && updateNercPerformanceCall()
      },
    })
  }

  const showInverterEventDilaog = _ => {
    if (inverterSelected.length > 1) {
      message.info('Please, Select only one row')
      return
    }
    setInverterEventDialog({
      isNew: false,
      visible: true,
      data: {
        eventtype: 'FO',
        ...inverterSelected[0],
        ...getplantIdandEntityId(),
        action: 'U',
      },
    })
  }

  const handleIsPerformacneSelected = value => {
    if (editInfo.updated.length > 0) {
      setShowValidationDialog({
        visible: true,
        value: value, // passing the value to the modal
        onYes: updateData, // function to call when "Yes" is clicked
        onNo: () => setIsPerformacneSelected(value), // correctly passing value to onNo handler
      })
    } else {
      setIsPerformacneSelected(value) // directly setting the value if no updates
    }
  }

  const isEditableComp = ({ header }) => {
    const { ident } = header
    // if (!isEditable) return false
    if (
      ident === 'modifier' ||
      ident === 'modifiedDate' ||
      ident === 'inverterId' ||
      ident === 'eventId'
    )
      return false
    return true
  }

  const editRow = editInfo => (data, setEditInfo, setData) => {
    const modData = data.map(d => {
      if (editInfo.updatedMap.get(d)) {
        return {
          ...editInfo.updatedMap.get(d),
          modificationInfo: undefined,
          updated: true,
        }
      } else {
        return d
      }
    })

    let editData = editInfo.updated
    editData = editData.map(d => ({
      ...d,
      modificationInfo: undefined,
    }))
    setEditInfo({ ...editInfo, updated: editData })
    setData(modData)
  }

  // const dateEditor = props => {
  //   const { data, header, rowIndex, style, getInputProps, cancelEdit } = props
  //   const { onChange, value } = getInputProps({ refKey: 'innerRef' })
  //   return (
  //     <DatePicker
  //       value={value ? moment(value) : null}
  //       showTime={{
  //         format: 'h:mm',
  //         defaultValue: moment('00:00', 'HH:mm'),
  //       }}
  //       onChange={date => {
  //         const newEditInfo = freeEditEngine.updateRow({
  //           editInfo,
  //           currentRow: data[rowIndex],
  //           editedRow: {
  //             ...data[rowIndex],
  //             [header.ident]: date ? date.format(header.dataFormat) : null,
  //           },
  //         })
  //         editRow(newEditInfo)
  //         data[rowIndex][header.ident] = date
  //           ? date.format(header.dataFormat)
  //           : null
  //         onChange({
  //           target: { value: date ? date.format(header.dataFormat) : date },
  //         })
  //       }}
  //       style={{
  //         ...style,
  //         padding: '0px 2px',
  //       }}
  //       format={header.displayFormat}
  //       size="small"
  //       onOpenChange={status => {
  //         if (!status) cancelEdit()
  //       }}
  //       allowClear={header.allowClear}
  //       suffixIcon={null}
  //       // bordered={false}
  //     />
  //   )
  // }

  const dateEditor = props => {
    const { data, header, rowIndex, style, getInputProps, cancelEdit } = props
    const { onChange, value } = getInputProps({ refKey: 'innerRef' })
    return (
      <DatePicker
        value={value ? moment(value) : null}
        showTime={{
          format: 'h:mm',
          defaultValue: moment('00:00', 'HH:mm'),
        }}
        onChange={date => {
          const newEditInfo = freeEditEngine.updateRow({
            editInfo,
            currentRow: data[rowIndex],
            editedRow: {
              ...data[rowIndex],
              [header.ident]: date ? date.format(header.dataFormat) : null,
            },
          })
          // setEditDataInfo(newEditInfo)
          editRow(newEditInfo)(
            mapIsPerformacneSelected[isPerformacneSelected].data,
            setEditInfo,
            mapIsPerformacneSelected[isPerformacneSelected].setData
          )
          data[rowIndex][header.ident] = date
            ? date.format(header.dataFormat)
            : null
          onChange({
            target: { value: date ? date.format(header.dataFormat) : date },
          })
        }}
        style={{
          ...style,
          padding: `0px`,
          margin: `0px`,
          paddingLeft: `10px`,
          borderTop: `0px solid #fff`,
        }}
        format={header.displayFormat}
        size="small"
        onOpenChange={status => {
          if (!status) cancelEdit()
        }}
        allowClear={header.allowClear}
        suffixIcon={null}
        // bordered={false}
        open
      />
    )
  }

  const inverterEventDoubleClick = props => {
    const { gridToolProps, reactVirtualizedProps } = props

    const { getCellProps, headers, data } = gridToolProps

    const { columnIndex, rowIndex, style } = reactVirtualizedProps
    const type = gridToolProps.headers[reactVirtualizedProps.columnIndex].type

    if (headers[columnIndex].ident === 'eventId') {
      let modifierProps = getCellProps({
        rowIndex,
        columnIndex,
        header: headers.find(h => h.ident === 'eventId'),
        data,
        style,
      })
      const cellData = extractAndFormatData({
        rowData: data[rowIndex],
        header: headers[columnIndex],
      })
      // const modifiercellData = extractAndFormatData({
      //   rowData: data[rowIndex],
      //   header: headers.find(h=>h.ident==='modifier'),
      // })
      const modifiercellData = (data[rowIndex].modificationInfo || { user: '' })
        .user

      const isSystemUser = R.toLower(modifiercellData || '').includes('system')

      const backgroundColor = isSystemUser ? '#c5e0b4' : '#ffff00'
      const color = isSystemUser ? 'black' : 'black'

      if (modifiercellData) {
        // eslint-disable-next-line no-unused-vars
        let { style, data, isSelected, ...rest } = modifierProps
        style = {
          ...style,
          backgroundColor,
          color: isSelected ? color : undefined,
        }
        modifierProps = { ...rest, style, isSelected }
      }
      return (
        <VirtualizedCell
          {...R.omit(['data'], modifierProps)}
          // onDoubleClick={_ => {
          //   // onUpdate()
          //   !isPlantLocked && showInverterEventDilaog()
          // }}
        >
          {cellData}
        </VirtualizedCell>
      )
    }

    return defaultVirtualizedCellRender({
      ...props,
      style,
      editRender:
        type === 'date' || type === 'date-time' ? dateEditor : undefined,
    })
  }

  const updateData = _ => {
    const effectiveData = mapIsPerformacneSelected[isPerformacneSelected]?.data
    // const od = origData[isPerformacneSelected]
    const updateApi = mapIsPerformacneSelected[isPerformacneSelected]?.updateApi
    const saveData = freeEditEngine.applyEdits({
      data: effectiveData?.filter(d => d.updated),
      // data: od,
      editInfo,
    })

    if (saveData.length <= 0) {
      message.error('Please, update data')
      return
    }

    setSpinning(true)

    updateApi(targetInfo)(saveData).fork(setError, errorList => {
      setSpinning(false)
      if (errorList.length > 0) setTmpError(errorList)
      if (!isErrorContains(errorList)) {
        message.info('Data updated.')
        setEditInfo(freeEditEngine.generateInitialEditInfo())
        retrieveData()
      }
    })
  }

  // const inverterEventDoubleClick = props => {
  //   const { gridToolProps, reactVirtualizedProps } = props

  //   const { getCellProps, headers, data } = gridToolProps

  //   const { columnIndex, rowIndex, style } = reactVirtualizedProps

  //   if (headers[columnIndex].ident === 'eventId') {
  //     let modifierProps = getCellProps({
  //       rowIndex,
  //       columnIndex,
  //       header: headers.find(h => h.ident === 'eventId'),
  //       data,
  //       style,
  //     })
  //     const cellData = extractAndFormatData({
  //       rowData: data[rowIndex],
  //       header: headers[columnIndex],
  //     })
  //     // const modifiercellData = extractAndFormatData({
  //     //   rowData: data[rowIndex],
  //     //   header: headers.find(h=>h.ident==='modifier'),
  //     // })
  //     const modifiercellData = (data[rowIndex].modificationInfo || { user: '' })
  //       .user

  //     const isSystemUser = R.toLower(modifiercellData || '').includes('system')

  //     const backgroundColor = isSystemUser ? '#c5e0b4' : '#ffff00'
  //     const color = isSystemUser ? 'black' : 'black'

  //     if (modifiercellData) {
  //       // eslint-disable-next-line no-unused-vars
  //       let { style, data, isSelected, ...rest } = modifierProps
  //       style = {
  //         ...style,
  //         backgroundColor,
  //         color: isSelected ? color : undefined,
  //       }
  //       modifierProps = { ...rest, style, isSelected }
  //     }
  //     return (
  //       <VirtualizedCell
  //         {...R.omit(['data'], modifierProps)}
  //         // onDoubleClick={_ => {
  //         //   // onUpdate()
  //         //   !isPlantLocked && showInverterEventDilaog()
  //         // }}
  //       >
  //         {cellData}
  //       </VirtualizedCell>
  //     )
  //   }

  //   return defaultVirtualizedCellRender({
  //     ...props,
  //     // onDoubleClick: _ => {
  //     //   !isPlantLocked && showInverterEventDilaog()
  //     // },
  //   })
  // }

  const getSelectedPlantDetails = useMemo(
    _ => {
      return plantSelectionData.find(f => f.plantId === plantSelected) || {}
    },
    [plantSelected, plantSelectionData]
  )
  const callCreateInverterEventData = _ => {
    setSpinning(true)
    createSolarInvPerormanceWithInvEvents(targetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      plantid: plantSelected,
    }).fork(setError, tmpError => {
      setSpinning(false)
      setTmpError(tmpError)
      if (!isErrorContains(tmpError)) {
        message.info('Process completed successfully.')
        retrieveData()
      }
    })
  }

  const createInverterData = _ => {
    if (!plantSelected) {
      message.info('Please, Select Plant')
      return
    }
    if (isImpactIsSequence) {
      // message.info('Month is out of Sequence.')
      callImpactAnalysisApi(callCreateInverterEventData, CREATE)
    } else {
      callCreateInverterEventData()
    }
  }

  // const onProcessEventsOnly = _ => {
  //   if (!plantSelected) {
  //     message.info('Please, Select Plant')
  //     return
  //   }
  //   setSpinning(true)
  //   solarProcessCreateEventData(targetInfo)({
  //     year: selectedDate.format('YYYY'),
  //     month: selectedDate.format('MM'),
  //     plantid: plantSelected,
  //   }).fork(setError, tmpError => {
  //     setSpinning(false)
  //     if (!isErrorContains(tmpError)) {
  //       message.info('Process finished.')
  //       retrieveData()
  //     }
  //     setTmpError(tmpError)
  //   })
  // }

  // const onProcessPerformaceOnly = _ => {
  //   if (!plantSelected) {
  //     message.info('Please, Select Plant')
  //     return
  //   }
  //   setSpinning(true)
  //   solarProcessPerformanceData(targetInfo)({
  //     year: selectedDate.format('YYYY'),
  //     month: selectedDate.format('MM'),
  //     plantid: plantSelected,
  //   }).fork(setError, tmpError => {
  //     setSpinning(false)
  //     if (!isErrorContains(tmpError)) {
  //       message.info('Process finished.')
  //       retrieveData()
  //     }
  //     setTmpError(tmpError)
  //   })
  // }

  const callProcessEventBoth = _ => {
    setSpinning(true)
    solarProcessEventAndPerformanceData(targetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      plantid: plantSelected,
      type:
        checkedValues.includes('P') && checkedValues.includes('E')
          ? 'A'
          : checkedValues[0],
    }).fork(setError, tmpError => {
      setSpinning(false)
      if (!isErrorContains(tmpError)) {
        message.info('Process finished.')
        retrieveData()
      }
      setTmpError(tmpError)
    })
  }

  const onProcessEventsBoth = _ => {
    if (!plantSelected) {
      message.info('Please, Select Plant')
      return
    }
    if (checkedValues.length <= 0) {
      message.info('Please, Select Process Type')
      return
    }
    if (isImpactIsSequence) {
      // message.info('Month is out of Sequence.')
      callImpactAnalysisApi(callProcessEventBoth, PROCESS)
    } else {
      // callProcessEventBoth()
    }
  }

  const deleteNercEvent = _ => {
    setSpinning(true)
    solarEventDelete(targetInfo)(eventSelected).fork(setError, errorList => {
      setSpinning(false)
      setTmpError(errorList)
      if (!isErrorContains(errorList)) {
        message.info('Data saved.')
        retrieveData()
      }
    })
  }

  const showNercEventUpdateDialog = _ => {
    if (eventSelected.length > 1) {
      message.info('Please, Select only one row')
      return
    }
    setEventDialog({
      isNew: false,
      visible: true,
      data: {
        eventtype: 'FO',
        ...eventSelected[0],
        ...getplantIdandEntityId(),
        action: 'U',
      },
    })
  }

  const onInsertNERCEvent = _ => {
    setEventDialog({
      isNew: false,
      visible: true,
      data: {
        isNew: true,
        visible: true,
        eventType: 'FO',
        eventtype: 'FO',
        ...getplantIdandEntityId(),
        action: 'A',
        eventstart: selectedDate
          .clone()
          .startOf('month')
          .format(saveDateformat),
        eventstartTimeZone: getTimeZone({
          pzone: getSelectedPlantDetails.timeZone,
          daylightSavings: getSelectedPlantDetails.daylightSaving,
          date: selectedDate
            .clone()
            .startOf('month')
            .format(saveDateformat),
        }),
      },
    })
  }

  const nercEventDoubleClick = props => {
    const { gridToolProps, reactVirtualizedProps } = props

    const { getCellProps, headers, data } = gridToolProps

    const { columnIndex, rowIndex, style } = reactVirtualizedProps
    const type = gridToolProps.headers[reactVirtualizedProps.columnIndex].type
    if (headers[columnIndex].ident === 'eventId') {
      let modifierProps = getCellProps({
        rowIndex,
        columnIndex,
        header: headers.find(h => h.ident === 'eventId'),
        data,
        style,
      })
      const cellData = extractAndFormatData({
        rowData: data[rowIndex],
        header: headers[columnIndex],
      })
      // const modifiercellData = extractAndFormatData({
      //   rowData: data[rowIndex],
      //   header: headers.find(h=>h.ident==='modifier'),
      // })
      const modifiercellData = (data[rowIndex].modificationInfo || { user: '' })
        .user

      const isSystemUser = R.toLower(modifiercellData || '').includes('system')

      const backgroundColor = isSystemUser ? '#c5e0b4' : '#ffff00'
      const color = isSystemUser ? 'black' : 'black'
      if (modifiercellData) {
        // eslint-disable-next-line no-unused-vars
        let { style, data, isSelected, ...rest } = modifierProps
        style = {
          ...style,
          backgroundColor,
          color: isSelected ? color : undefined,
        }
        modifierProps = { ...rest, style, isSelected }
      }
      return (
        <VirtualizedCell
          {...R.omit(['data'], modifierProps)}
          // onDoubleClick={_ => {
          //   // onUpdate()
          //   !isPlantLocked && showNercEventUpdateDialog()
          // }}
        >
          {cellData}
        </VirtualizedCell>
      )
    }
    return defaultVirtualizedCellRender({
      ...props,
      style,
      editRender:
        type === 'date' || type === 'date-time' ? dateEditor : undefined,
    })
  }

  const isImpactIsSequence = useMemo(
    _ => {
      const mnt = moment()
        .startOf('month')
        .startOf('day')
      return !selectedDate
        .clone()
        .startOf('month')
        .startOf('day')
        .isAfter(mnt)
    },
    [selectedDate]
  )

  const CREATE = 'CREATE'
  const PROCESS = 'PROCESS'

  const impactAnalysisExecuteApi = createorprocess =>
    solarImpactAnalysis(targetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      plantid: plantSelected,
      mode: 'EXECUTE',
      createorprocess,
      recalcInverterperf,
    })

  // // eslint-disable-next-line no-unused-vars
  const callImpactAnalysisExecuteApi = createorprocess => {
    setSpinning(true)
    impactAnalysisExecuteApi(createorprocess).fork(setError, data => {
      setSpinning(false)
      const { errors } = data
      // if (errors.length > 0) setTmpError(errors)
      if (!isErrorContains(errors)) {
        setTmpError(
          errors,
          _ => {
            message.info('Process Finished')
            if (errors.length <= 0) {
              setImpactAnalysisDialog(false)
              retrieveData()
            }
          },
          _ => {
            setImpactAnalysisDialog(false)
            retrieveData()
          }
        )
      } else {
        setTmpError(errors)
      }
    })
  }

  const impactAnalysisApi = createorprocess =>
    solarImpactAnalysis(targetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      plantid: plantSelected,
      mode: 'ANALYZE',
      createorprocess,
      recalcInverterperf,
    })

  // impact found means it s the error
  // const isImpactANalysisError = summary => summary.find(f => f.impactYN === 'Y')

  const callImpactAnalysisApi = (mainCall, createorprocess) => {
    setSpinning(true)
    impactAnalysisApi(createorprocess).fork(setError, data => {
      setSpinning(false)

      const { impactSummary = [] } = data
      const isNotValidDAta = impactSummary.filter(
        f => f.tabId === '0' && f.impactYN === 'Y'
      )

      if (isNotValidDAta.length > 0) {
        setImpactAnalysisDialog(true)
        setImpactAnalysisData({ ...data, createorprocess })

        // mainCall()
      } else {
        message.info('All events and performance data are up to date.')
      }
    })
  }
  const solarTmpNercDataReportHeaders = [
    strCol({
      ident: 'plantId',
      display: 'Plant Id',
      isFiltered: true,
      sortOrder: 'asc',
      width: 150,
    }),
    dateTimeCol({
      ident: 'periodFrom',
      display: 'Period From',
      isFiltered: true,
      sortOrder: 'asc',
      width: 250,
    }),
    dateTimeCol({
      ident: 'periodTo',
      display: 'Period To',
      isFiltered: true,
      sortOrder: 'asc',
      width: 250,
    }),
    strCol({
      ident: 'nercEvent',
      display: 'NERC Event',
      isFiltered: true,
      sortOrder: 'asc',
      width: 150,
    }),
    intCol({
      ident: 'causecode',
      display: 'Cause Code',
      width: 150,
      ellipsis: true,
    }),
    strCol({
      ident: 'description',
      display: 'Description',
      width: 700,
      ellipsis: true,
    }),
    numCol({
      ident: 'foReduction',
      display: 'FO Reduction',
      isFiltered: true,
      sortOrder: 'asc',
      width: 150,
    }),
    numCol({
      ident: 'foNadir',
      display: 'FO Nadir',
      isFiltered: true,
      sortOrder: 'asc',
      width: 150,
    }),
    numCol({
      ident: 'foPercentRecovered',
      display: 'FO Percent Recovered',
      isFiltered: true,
      sortOrder: 'asc',
      width: 250,
    }),
    numCol({
      ident: 'cumulativeMwhLoss',
      display: 'Cumulative MWh Loss',
      isFiltered: true,
      sortOrder: 'asc',
      width: 200,
    }),
  ]

  const exportData = async data => {
    const exportHeader = solarTmpNercDataReportHeaders

    const columns = toXlsxColumns(exportHeader)
    setSpinning(true)

    const ed = toXlsxData(data, exportHeader)

    const worksheet = [
      {
        name: 'nerc-data',
        columns,
        data: ed,
        metaInfo: [],
        colorInfo: [],
      },
    ]

    const fileBlob = await writeToExcel(worksheet)
    setSpinning(false)
    saveAs(fileBlob, 'nerc-data')
  }

  const exportNercData = (_, cdate = selectedDate) => {
    if (!plantSelected) {
      message.info('Please, Select Plant')
      return
    }
    setSpinning(true)
    exportSolarInverterData(targetInfo)({
      year: cdate.format('YYYY'),
      month: cdate.format('MM'),
      plantid: plantSelected,
      mode: 'ANALYZE',
    }).fork(setError, data => {
      setSpinning(false)
      exportData(data)
    })
  }

  const JobSProcessInfo = ({ recalcInverterperf, setRecalcInverterPerf }) => {
    if (!hasSolarPowerDataWritePermission) return <div />

    return (
      <Content
        style={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
          gap: 5,
          marginTop: '10px',
          paddingBottom: '10px',
          paddingTop: '10px',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns1: '100px 150px 200px 10px 200px',
            gridTemplateColumns: '200px auto',
            gridTemplateRows: 'auto auto auto',
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <h3>Run Job</h3>
          </div>
          <div />
          <Button
            type="primary"
            onClick={createInverterData}
            icon="database"
            style={{ width: '100%' }}
            // disabled={!isImpactIsSequence}
            disabled={!isImpactIsSequence || !(isRetrived && !isPlantLocked)}
          >
            Create All Data
          </Button>

          <div />
          <div style={{ gridColumnEnd: 'span 2' }}>
            This process will create Inverter level and NERC level Events and
            Performance Data. All existing manually edited data will be
            replaced. An impact analysis will be presented before executing.
          </div>
        </div>
        <Divider type="vertical" style={{ height: '100%' }} />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '200px 210px auto',
            gap: '5px',
          }}
        >
          <div
            style={{
              gridRowEnd: 'span 1',
              display: 'grid',
              justifyItems: 'center',
              alignContent: 'baseline',
            }}
          >
            <div style={{ textAlign: 'center' }}>
              <h3>Recreate NERC Data</h3>
            </div>
            <Button
              type="primary"
              onClick={onProcessEventsBoth}
              // disabled={!isImpactIsSequence}
              disabled={!isImpactIsSequence || !(isRetrived && !isPlantLocked)}
              icon="database"
            >
              Process All Data
            </Button>
          </div>
          {showRecalcCheckbox && (
            <div>
              <div style={{ height: '30px' }} />
              <Tooltip title="When selected process will update the inverter level performance data based on inverter events.">
                <Checkbox
                  style={{ padding: '5px 0px' }}
                  checked={recalcInverterperf === 'Y'}
                  onChange={e =>
                    setRecalcInverterPerf(e.target.checked ? 'Y' : 'N')
                  }
                  disabled={
                    !isImpactIsSequence || !(isRetrived && !isPlantLocked)
                  }
                >
                  Recalc Inverter Performance
                </Checkbox>
              </Tooltip>
            </div>
          )}
          {/* <div
            style={{
              display: 'grid',
              gridTemplateColumns: '80px max-content 120px max-content',
              rowGap: 5,
              columnGap: 5,
              width: '350px',
            }}
          >
            <div>
              <Label>
                <h4>NERC :</h4>
              </Label>
            </div>

            {!isModificationExits && (
              <div style={{ color: 'green' }}>
                <Icon type="check-square" theme="twoTone" /> Processed
              </div>
            )}
            {isModificationExits && (
              <div style={{ color: 'red' }}>
                {[
                  <div key="1">
                    <Icon type="close-square" theme="twoTone" />{' '}
                    Unprocessed,Modifications exist
                  </div>,
                ]}
              </div>
            )}
            <div>
              <Label>
                <h4>Last Modified :</h4>
              </Label>
            </div>
            <div>
              {lastModifiedDate &&
                moment(lastModifiedDate).format('MM/DD/YYYY HH:mm:ss')}
            </div>

            <div>
              <Label>
                <h4>Inverter :</h4>
              </Label>
            </div>
            {!isModificationExitsInverter && (
              <div style={{ color: 'green' }}>
                <Icon type="check-square" theme="twoTone" /> Processed
              </div>
            )}
            {isModificationExitsInverter && (
              <div style={{ color: 'red' }}>
                {[
                  <div key="1">
                    <Icon type="close-square" theme="twoTone" />{' '}
                    {' Unprocessed,Modifications exist'}
                  </div>,
                ]}
     isEditableComp         </div>
            )}
            <div>
              <Label>
                <h4>Last Run :</h4>
              </Label>
            </div>
            <div>
              {lastRunTime && moment(lastRunTime).format('MM/DD/YYYY HH:mm:ss')}
            </div>
          </div> */}
          <div style={{ gridColumnEnd: 'span 3' }}>
            This process will regenerate NERC Event and Performance Data using
            existing Inverter level data, including manually edited records. An
            impact analysis will be presented before executing.
          </div>
        </div>
      </Content>
    )
  }

  const [
    showInverterEventUpdateCauseCodechnagedialog,
    setShowInverterEventUpdateCauseCodechnagedialog,
  ] = useState(false)

  useEffect(
    _ => {
      const curData = origData[isPerformacneSelected]
      if (isPerformacneSelected === 'P') {
        // edit=editInfo => (data, setEditInfo, setData)

        setGridProps(
          getGridPropsObj(
            PerformanceHeaderFormater,
            curData,
            setPerformanceData
            // data=> editRow(editInfo) (data,setEditInfo,setPerformanceData)
          )
        )
      } else if (isPerformacneSelected === 'E') {
        setGridProps(
          getGridPropsObj(
            SolarInverterEventHeaders(30),
            curData,
            setInverterEventData
          )
        )
      } else if (isPerformacneSelected === 'N') {
        // const call = data => editRow(editInfo)(data, setEditInfo, setEventData)
        const call = data => {
          const dt = data.map(d => {
            if (editInfo.updatedMap.get(d)) {
              return {
                ...editInfo.updatedMap.get(d),
                updated: true,
              }
            } else {
              return d
            }
          })
          setEventData(dt)
        }
        setGridProps(getGridPropsObj(EventHeader(30), curData, call))
      } else if (isPerformacneSelected === 'NP') {
        setGridProps(
          getGridPropsObj(
            NercPerformanceHeaderFormater,
            curData,
            setNercPerformanceData
          )
        )
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      EventHeader,
      NercPerformanceHeaderFormater,
      PerformanceHeaderFormater,
      SolarInverterEventHeaders,
      isPerformacneSelected,
      origData,
      setGridProps,
      // editInfo, // removed all the filters after its call bcoz of editinfo
    ]
  )
  const openFilterDialog = e => {
    if (editInfo.updated.length > 0) {
      message.warn('Please, Save data')
      return
    }
    setDrawerVisible(true)
  }

  return (
    <div>
      <CriteriaRow>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '300px 250px 200px 150px auto auto auto auto',
            gap: '10px',
            width: '100%',
          }}
        >
          <Title>Solar Inverter Data</Title>
          <Select
            showSearch
            value={plantSelected}
            style={{ width: '100%' }}
            onChange={plantId => {
              setPlantSelected([plantId])
              clearData()
            }}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {plantSelectionData.map(({ plantName, plantId }) => (
              <Select.Option key={plantId} value={plantId}>
                {plantName}
              </Select.Option>
            ))}
          </Select>
          <DatePicker.MonthPicker
            allowClear={false}
            style={{ width: '100%' }}
            format="MMMM-YYYY"
            value={selectedDate}
            onChange={d => {
              setSelectedDate(d.endOf('month'))
              clearData()
            }}
          />

          <Button.Group style={{ minWidth: '130px', marginLeft: '10px' }}>
            <Button
              title="Previous Month"
              style={{ marginLeft: '10px' }}
              type="primary"
              onClick={() => {
                clearData()
                const dt = selectedDate
                  .clone()
                  .subtract(1, 'M')
                  .endOf('month')
                setSelectedDate(dt)
                retrieveData(true, dt)
              }}
            >
              <Icon type="left" />
            </Button>

            <Button
              title="Next Month"
              style={{}}
              type="primary"
              onClick={() => {
                clearData()
                const dt = selectedDate
                  .clone()
                  .add(1, 'M')
                  .endOf('month')
                setSelectedDate(dt)
                retrieveData(true, dt)
              }}
            >
              <Icon type="right" />
            </Button>
          </Button.Group>
          <Button
            type="primary"
            onClick={() => retrieveData(true)}
            icon="database"
            style={{ width: '150px' }}
          >
            Retrieve
          </Button>

          <Button
            onClick={openFilterDialog}
            type="dashed"
            icon="filter"
            disabled={!isRetrived}
          >
            Filter Data ({effectvieFilterCount(filterCondition)})
          </Button>

          <Filler />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr' }}>
            {isRetrived && (
              <div style={{ display: 'flex' }}>
                <Label>
                  <b>Plant Status : </b>
                </Label>
                <Icon
                  type={isPlantLocked ? 'lock' : 'unlock'}
                  style={{
                    fontSize: '30px',
                  }}
                  theme="twoTone"
                />
              </div>
            )}
          </div>
        </div>
        <Filler />
        <div style={{ display: 'grid', justifyContent: 'end' }}>
          <Button
            type={isRetrived ? 'primary' : 'default'}
            // onClick={exportNercData}
            onClick={exportNercData}
            disabled={!isRetrived}
            icon="database"
            style={{
              marginLeft: '20px',
              backgroundColor: isRetrived ? 'green' : undefined,
            }}
          >
            NERC Event Audit
          </Button>
        </div>

        <ExportComponent
          getData={_ =>
            exportDataComponent(
              mapIsPerformacneSelected[isPerformacneSelected].ref,
              mapIsPerformacneSelected[isPerformacneSelected].data,
              mapIsPerformacneSelected[isPerformacneSelected].exportHeader ||
                mapIsPerformacneSelected[isPerformacneSelected].header
            )
          }
          data={mapIsPerformacneSelected[isPerformacneSelected].data}
          headers={
            mapIsPerformacneSelected[isPerformacneSelected].exportHeader ||
            mapIsPerformacneSelected[isPerformacneSelected].header
          }
          fileName={mapIsPerformacneSelected[isPerformacneSelected].title}
          btnStyle={{ marginRight: '10px', marginLeft: '10px' }}
          disabled={
            !!(
              mapIsPerformacneSelected[isPerformacneSelected].data &&
              mapIsPerformacneSelected[isPerformacneSelected].data.length <= 0
            )
          }
        />
      </CriteriaRow>
      <JobSProcessInfo
        recalcInverterperf={recalcInverterperf}
        setRecalcInverterPerf={setRecalcInverterPerf}
      />

      <FullHeightSizer
        heightOffset={hasSolarPowerDataWritePermission ? 350 : 220}
        // heightOffset={200}
        widthOffset={20}
      >
        {({ height, width }) => (
          <Content style={{ padding: '10px', height, width }}>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: width - 200 + 'px',
                gap: '10px',
              }}
            >
              <div
                style={{
                  gap: '15px',
                  display: 'grid',
                  gridTemplateColumns:
                    '300px auto 450px auto 250px 100px 100px 100px 100px 150px',
                  paddingRight: '40px',
                  alignItems: 'baseline',
                  // alignContent: 'center',
                  gridColumnEnd: 'span 2',
                  // justifyContent: 'end',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'max-content 300px',
                    gap: '5px',
                  }}
                >
                  <Label>Select : </Label>
                  <Select
                    showSearch
                    onChange={value => {
                      handleIsPerformacneSelected(value)
                      // setTimeout(_ => setGridProps(emptyFilterObj), 1000)
                    }}
                    value={isPerformacneSelected}
                    width={300}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Select.Option value="NP">NERC Performance</Select.Option>
                    <Select.Option value="P">
                      Inverter Performance
                    </Select.Option>
                    <Select.Option value="N">NERC Events</Select.Option>
                    <Select.Option value="E">Inverter Events</Select.Option>
                  </Select>
                </div>
                <div />
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '10px 90px 50px 150px 50px 10px',
                    justifyContent: 'center',
                    gap: '5px',
                    borderLeft: '0px solid gray',
                    borderRight: '0px solid gray',
                  }}
                >
                  <Divider
                    type="vertical"
                    style={{ height: '100%', backgroundColor: '#8080807a' }}
                  />
                  <div style={{ textAlign: 'end' }}>Automated</div>
                  <div
                    style={{
                      backgroundColor: '#c5e0b4',
                      border: '0px solid black',
                      textAlign: 'center',
                      fontWeight: '700',
                      color: '#c5e0b4',
                      height: '70%',
                      alignSelf: 'center',
                    }}
                  />
                  <div style={{ textAlign: 'end' }}>Manually Update</div>
                  <div
                    style={{
                      backgroundColor: '#ffff00',
                      border: '0px solid black',
                      textAlign: 'center',
                      fontWeight: '700',
                      color: '#ffff00',
                      height: '70%',
                      alignSelf: 'center',
                    }}
                  />
                  <Divider
                    type="vertical"
                    style={{ height: '100%', backgroundColor: '#8080807a' }}
                  />
                </div>
                <div />
                <Input.Search
                  placeholder="Filter"
                  value={fuzzyFilter}
                  style={{
                    gridColumnEnd: 'span 1',
                  }}
                  onChange={e => setFuzzyFilter(e.target.value)}
                />

                {isPerformacneSelected === 'N' && (
                  <React.Fragment>
                    {hasSolarPowerDataWritePermission && (
                      <Button
                        key="1"
                        style={{ paddingRight: '10px' }}
                        onClick={onInsertNERCEvent}
                        disabled={!(isRetrived && !isPlantLocked)}
                        type="primary"
                      >
                        Add
                      </Button>
                    )}
                    <Button
                      key="2"
                      style={{ paddingRight: '10px' }}
                      disabled={
                        !(
                          isRetrived &&
                          !isPlantLocked &&
                          eventSelected.length > 0
                        )
                      }
                      onClick={showNercEventUpdateDialog}
                      type="primary"
                    >
                      {hasSolarPowerDataWritePermission ? 'Update' : 'View'}
                    </Button>
                    {hasSolarPowerDataWritePermission && (
                      <Button
                        disabled={
                          !(
                            isRetrived &&
                            !isPlantLocked &&
                            !editInfo.updated.length <= 0
                          )
                        }
                        onClick={updateData}
                        type="primary"
                      >
                        Save
                      </Button>
                    )}
                    {hasSolarPowerDataWritePermission && (
                      <Popconfirm
                        key="3"
                        title="Delete the task ?"
                        description="Are you sure to delete this task?"
                        onConfirm={deleteNercEvent}
                        onCancel={_ => _}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button
                          disabled={
                            !(
                              isRetrived &&
                              !isPlantLocked &&
                              eventSelected.length > 0
                            )
                          }
                          style={{ width: '100%' }}
                          type="danger"
                        >
                          Delete
                        </Button>
                      </Popconfirm>
                    )}
                  </React.Fragment>
                )}

                {isPerformacneSelected === 'P' && (
                  <React.Fragment>
                    {hasSolarPowerDataWritePermission && (
                      <Button
                        key="1"
                        style={{ paddingRight: '10px' }}
                        onClick={insertPerformanceCall}
                        disabled={!(isRetrived && !isPlantLocked)}
                        type="primary"
                      >
                        Add
                      </Button>
                    )}
                    <Button
                      key="2"
                      style={{ paddingRight: '10px' }}
                      disabled={
                        !(
                          isRetrived &&
                          !isPlantLocked &&
                          performanceRowSelected.length > 0
                        )
                      }
                      onClick={updatePerformanceCall}
                      type="primary"
                    >
                      {hasSolarPowerDataWritePermission ? 'Update' : 'View'}
                    </Button>
                    {hasSolarPowerDataWritePermission && (
                      <Button
                        disabled={
                          !(
                            isRetrived &&
                            !isPlantLocked &&
                            !editInfo.updated.length <= 0
                          )
                        }
                        onClick={updateData}
                        type="primary"
                      >
                        Save
                      </Button>
                    )}
                    {hasSolarPowerDataWritePermission && (
                      <Popconfirm
                        key="3"
                        title="Delete the task ?"
                        description="Are you sure to delete this task?"
                        onConfirm={deletePerformacneCall}
                        onCancel={_ => _}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button
                          disabled={
                            !(
                              isRetrived &&
                              !isPlantLocked &&
                              performanceRowSelected.length > 0
                            )
                          }
                          style={{ width: '100%' }}
                          type="danger"
                        >
                          Delete
                        </Button>
                      </Popconfirm>
                    )}
                  </React.Fragment>
                )}

                {isPerformacneSelected === 'NP' && [
                  <Button
                    key="2"
                    style={{ paddingRight: '10px' }}
                    disabled={
                      !(
                        isRetrived &&
                        !isPlantLocked &&
                        nercPerformanceRowSelected.length > 0
                      )
                    }
                    onClick={updateNercPerformanceCall}
                    type="primary"
                  >
                    {hasSolarPowerDataWritePermission ? 'Update' : 'View'}
                  </Button>,
                ]}

                {isPerformacneSelected === 'E' && (
                  <React.Fragment>
                    {hasSolarPowerDataWritePermission && (
                      <Button
                        disabled={!(isRetrived && !isPlantLocked)}
                        type="primary"
                        onClick={_ => {
                          setInverterEventDialog({
                            isNew: true,
                            visible: true,
                            data: {
                              ...getplantIdandEntityId(),
                              action: 'A',
                              eventtype: 'FO',
                              eventstart: selectedDate
                                .clone()
                                .startOf('month')
                                .format(saveDateformat),
                              eventstartTimeZone: getTimeZone({
                                pzone: getSelectedPlantDetails.timeZone,
                                daylightSavings:
                                  getSelectedPlantDetails.daylightSaving,
                                date: selectedDate
                                  .clone()
                                  .startOf('month')
                                  .format(saveDateformat),
                                sortOrder: 'asc',
                              }),
                            },
                          })
                        }}
                      >
                        Add
                      </Button>
                    )}
                    <Button
                      disabled={
                        !(
                          isRetrived &&
                          !isPlantLocked &&
                          inverterSelected.length > 0
                        )
                      }
                      onClick={showInverterEventDilaog}
                      type="primary"
                    >
                      {hasSolarPowerDataWritePermission ? 'Update' : 'View'}
                    </Button>
                    {hasSolarPowerDataWritePermission && (
                      <Button
                        disabled={
                          !(
                            isRetrived &&
                            !isPlantLocked &&
                            !editInfo.updated.length <= 0
                          )
                        }
                        onClick={updateData}
                        type="primary"
                      >
                        Save
                      </Button>
                    )}
                    {hasSolarPowerDataWritePermission && (
                      <Popconfirm
                        title="Delete the task ?"
                        description="Are you sure to delete this task?"
                        onConfirm={deleteInverterEvent}
                        onCancel={_ => _}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button
                          disabled={
                            !(
                              isRetrived &&
                              !isPlantLocked &&
                              inverterSelected.length > 0
                            )
                          }
                          type="danger"
                          style={{ width: '100%' }}
                        >
                          Delete
                        </Button>
                      </Popconfirm>
                    )}
                    {hasSolarPowerDataWritePermission && (
                      <Button
                        disabled={
                          !(
                            isRetrived &&
                            !isPlantLocked &&
                            inverterEventData?.length > 0
                          )
                        }
                        onClick={_ =>
                          setShowInverterEventUpdateCauseCodechnagedialog(true)
                        }
                        type="primary"
                      >
                        Update Cause Code
                      </Button>
                    )}
                  </React.Fragment>
                )}
              </div>
              {isPerformacneSelected === 'N' && (
                <div style={{ gridColumnEnd: 'span 1', height: height }}>
                  <Grid
                    ref={nercEventGridRef}
                    data={eventData}
                    headers={EventHeader(width - 30)}
                    altBy={u => u.entityId}
                    altBgColor="#ebebeb"
                    onEditInfoChange={info =>
                      editRow(info)(eventData, setEditInfo, setEventData)
                    }
                    editInfo={editInfo}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 70,
                      width: width - 30,
                      headerRowHeight: 30,
                      cellRender: nercEventDoubleClick,
                    })}
                    fuzzyFilter={fuzzyFilter}
                    isEditable={!isPlantLocked && isEditableComp}
                    onSelectionChange={({ selectedRows }) => {
                      setEventSelected(selectedRows)
                    }}
                    selectionMode="multi"
                    // selectionType="row"
                    editMode="cell"
                  />
                </div>
              )}
              {isPerformacneSelected === 'P' && (
                <div style={{ gridColumnEnd: 'span 1', height: height }}>
                  <Grid
                    ref={inverterPerformanceGridRef}
                    sortEnabled
                    data={performanceData}
                    headers={PerformanceHeaderFormater}
                    altBy={u => u.subgroupName}
                    altBgColor="#ebebeb"
                    onEditInfoChange={info =>
                      editRow(info)(
                        performanceData,
                        setEditInfo,
                        setPerformanceData
                      )
                    }
                    editInfo={editInfo}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 70,
                      width: width - 30,

                      cellRender: performanceDoubleClick,
                    })}
                    fuzzyFilter={fuzzyFilter}
                    isEditable={!isPlantLocked && isEditableComp}
                    onSelectionChange={({ selectedRows }) => {
                      if (
                        selectedRows[0] &&
                        (selectedRows[0].subgroupName === 'TOTAL' ||
                          selectedRows[0].inverterGroupName === 'TOTAL')
                      )
                        setPerformanceRowSelected([])
                      else setPerformanceRowSelected(selectedRows)
                    }}
                    selectionMode="multi"
                    //  selectionType="row"
                    editMode="cell"
                    initialSortOptions={PerformanceHeaderFormater}
                  />
                </div>
              )}
              {isPerformacneSelected === 'NP' && (
                <div style={{ gridColumnEnd: 'span 1', height: height }}>
                  <Grid
                    ref={nercPerformanceGridRef}
                    sortEnabled
                    data={nercPerformanceData}
                    headers={NercPerformanceHeaderFormater}
                    altBy={u => u.subgroupName}
                    altBgColor="#ebebeb"
                    // onEditInfoChange={info => editRow(info)}
                    // editInfo={editInfo}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 70,
                      width: width - 30,

                      cellRender: nercPerformanceDoubleClick,
                    })}
                    fuzzyFilter={fuzzyFilter}
                    isEditable={false}
                    onSelectionChange={({ selectedRows }) => {
                      if (
                        selectedRows[0] &&
                        (selectedRows[0].subgroupName === 'TOTAL' ||
                          selectedRows[0].inverterGroupName === 'TOTAL')
                      )
                        setNercPerformanceRowSelected([])
                      else setNercPerformanceRowSelected(selectedRows)
                    }}
                    selectionMode="single"
                    selectionType="row"
                    initialSortOptions={NercPerformanceHeaderFormater}
                  />
                </div>
              )}
              {isPerformacneSelected === 'E' && (
                <div style={{ height: height }}>
                  <Grid
                    ref={inverterEventGridRef}
                    data={inverterEventData}
                    headers={SolarInverterEventHeaders(width - 30)}
                    altBy={u => u.entityId}
                    altBgColor="#ebebeb"
                    onEditInfoChange={info =>
                      editRow(info)(
                        inverterEventData,
                        setEditInfo,
                        setInverterEventData
                      )
                    }
                    editInfo={editInfo}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: height - 70,
                      width: width - 30,
                      headerRowHeight: 30,
                      cellRender: inverterEventDoubleClick,
                    })}
                    fuzzyFilter={fuzzyFilter}
                    isEditable={!isPlantLocked && isEditableComp}
                    onSelectionChange={({ selectedRows }) => {
                      setInverterSelected(selectedRows)
                    }}
                    selectionMode="multi"
                    // selectionType="row"
                    editMode="cell"
                    // initialSortOptions={SolarInverterEventHeaders(width - 30)}
                  />
                </div>
              )}
            </div>
          </Content>
        )}
      </FullHeightSizer>
      {showPerformanceDialog.visible && (
        <SolarInverterPerformanceDialog
          {...showPerformanceDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setPerformanceDialog({})
          }}
          onRetrieve={retrieveData}
          availableStatus={availableStatus}
          setTmpError={setTmpError}
          inverterIdBYPlant={inverterIdBYPlant}
        />
      )}

      {showInverterEventDialog.visible && (
        <SolarInverterEventDialog
          {...showInverterEventDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setInverterEventDialog({})
          }}
          onRetrieve={retrieveData}
          unitCodeMap={['SO']}
          contribConditionList={contribConditionList}
          causeCodeList={causecodeList}
          selectedPlantDetails={getSelectedPlantDetails}
          inverterIdBYPlant={inverterIdBYPlant}
          selectedDate={selectedDate.clone().startOf('d')}
          eventTypes={eventTypes}
        />
      )}
      {showEventDialog.visible && (
        <SolarEventDialog
          {...showEventDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setEventDialog({})
          }}
          onRetrieve={retrieveData}
          unitCodeMap={['SO']}
          contribConditionList={contribConditionList}
          causeCodeList={causecodeList}
          selectedPlantDetails={getSelectedPlantDetails}
          selectedDate={selectedDate.clone().startOf('month')}
          eventTypes={eventTypes}
        />
      )}
      {impactAnalysisDialog && (
        <ImpactAnalysis
          targetInfo={targetInfo}
          data={impactAnalysisData}
          createorprocess={impactAnalysisData.createorprocess}
          onClose={_ => setImpactAnalysisDialog(false)}
          visible={impactAnalysisDialog}
          setSpinning={setSpinning}
          spinning={spinning}
          request={{
            year: selectedDate.format('YYYY'),
            month: selectedDate.format('MM'),
            plantid: plantSelected,
            mode: 'ANALYZE',
            plantName: (
              plantSelectionData.find(f => f.plantId === plantSelected) || {}
            ).plantName,
          }}
          setError={setError}
          setImpactAnalysisData={setImpactAnalysisData}
          callImpactAnalysisExecuteApi={callImpactAnalysisExecuteApi}
          impactAnalysisApi={impactAnalysisApi}
          retrieveData={retrieveData}
          setTmpError={setTmpError}
        />
      )}
      {showNercPerformanceDialog.visible && (
        <SolarPerformanceDialog
          {...showNercPerformanceDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setNercPerformanceDialog({})
          }}
          onRetrieve={retrieveData}
          availableStatus={availableStatus}
          setTmpError={setTmpError}
        />
      )}
      {showValidationDialog.visible && (
        <SolarInverterValidationDialog
          {...showValidationDialog}
          // visible
          onHide={_ => {
            setShowValidationDialog({})
          }}
          onRevertData={() => {
            setShowValidationDialog({})
            setEditInfo(freeEditEngine.generateInitialEditInfo())
          }}
        />
      )}
      {showInverterEventUpdateCauseCodechnagedialog && (
        <InverterEventCauseCodeChangeDialog
          targetInfo={targetInfo}
          visible={showInverterEventUpdateCauseCodechnagedialog}
          eventTypes={eventTypes}
          setVisible={_ =>
            setShowInverterEventUpdateCauseCodechnagedialog(false)
          }
          plantId={plantSelected}
          curMonth={selectedDate}
          inverterIdBYPlant={inverterIdBYPlant}
          causeCodeList={causecodeList}
          setError={setError}
          setJcListError={setTmpError}
          onRetrieve={retrieveData}
        />
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
})
export default connect(mapStateToProps)(SolarInverterPerformacePowerData)

const InverterEventCauseCodeChangeDialog = ({
  targetInfo,
  visible,
  eventTypes,
  setVisible,
  plantId,
  curMonth,
  inverterIdBYPlant,
  causeCodeList,
  setError,
  setJcListError,
  onRetrieve,
}) => {
  const startMonth = curMonth.clone().startOf('month')
  const endMonth = curMonth.clone().endOf('month')
  const [data, setData] = useState({
    plantId,
    inverterIds: [],
    startDate: curMonth.clone().startOf('month'),
    endDate: curMonth.clone().endOf('month'),
    eventtype: ['FO'],
  })

  const onOk = _ => {
    if (data.inverterIds.length <= 0) {
      message.warn('Please, Select Inverter Id')
      return
    } else if (eventTypes.length <= 0) {
      message.warn('Please, Select Event Type')
      return
    } else if (!data.causecode) {
      message.warn('Please, Select Causecode')
      return
    }

    const effData = {
      ...data,
      eventtype: data.eventtype.includes('ALL')
        ? efffEventType.map(({ id }) => id)
        : data.eventtype,
      inverterIds: data.inverterIds.includes('ALL')
        ? inverterIdBYPlant.map(({ inverterId }) => inverterId)
        : data.inverterIds,
    }
    updateMultipleCaucecodeInverterEvent(targetInfo)({
      ...effData,
      startDate: data.startDate.format('MM/DD/YYYY'),
      endDate: data.endDate.format('MM/DD/YYYY'),
    }).fork(setError, data => {
      setJcListError(data)
      if (!isErrorContains(data)) {
        message.info('Data saved.')
        setVisible(false)
        onRetrieve()
      }
    })
  }

  const efffEventType = eventTypes.filter(f => f.eventFor === 'I')

  const [causeCodeDialog, setCauseCodedialog] = useState({
    causeCodeDialog: false,
  })

  const onCauseCodeDialogClose = (causeCodeKeyValues, causeCodeValues) => {
    setData({
      ...data,
      causecode: causeCodeValues[0] && causeCodeValues[0].causeCode,
    })
    setCauseCodedialog({
      causeCodeDialog: false,
      causeCodeKeyValues,
      causeCodeValues,
      causecode: causeCodeValues
        ? causeCodeValues.length > 0
          ? causeCodeValues[0].causeCode
          : ''
        : data.causecode,
    })
  }

  const onCauseCodeTreeCancel = causeCodeKeyValues => {
    setCauseCodedialog({
      causeCodeKeyValues,
      causeCodeDialog: false,
    })
  }
  const openCauseCodeDialog = _ => {
    setCauseCodedialog({
      causecode: data.causecode,
      causeCodeDialog: true,
    })
  }

  return (
    <div>
      <Modal
        visible={visible}
        height={400}
        centered
        width={600}
        title={<div>Update Cause Code</div>}
        onOk={onOk}
        onCancel={_ => setVisible(false)}
        okText="Update Cause Code"
      >
        <Tabs type="card">
          <Tabs.TabPane
            tab="Criteria"
            style={{ border: '1px solid #d9d9d9', padding: 10 }}
          >
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '100px 150px 100px 150px',
                gap: 10,
              }}
            >
              <Label>Start Date :</Label>
              <DatePicker
                allowClear={false}
                style={{ width: '100%' }}
                format="MM/DD/YYYY"
                value={data.startDate}
                onChange={d => {
                  setData({ ...data, startDate: d })
                }}
                disabledDate={date =>
                  date.isBefore(startMonth) || date.isAfter(endMonth)
                }
              />
              <Label>End Date :</Label>
              <DatePicker
                allowClear={false}
                style={{ width: '100%' }}
                format="MM/DD/YYYY"
                value={data.endDate}
                onChange={d => {
                  setData({ ...data, endDate: d })
                }}
                disabledDate={
                  date => date.isBefore(startMonth) || date.isAfter(endMonth)
                  //  || date.isBefore(data.startDate)
                }
              />
              <Label>Event Types :</Label>
              <Select
                value={data.eventtype}
                onChange={eventtype => setData({ ...data, eventtype })}
                style={{ gridColumnEnd: 'span 3' }}
                mode="multiple"
                allowClear
              >
                <Select.Option key="ALL" value="ALL">
                  ALL
                </Select.Option>

                {efffEventType.map(d => (
                  <Select.Option key={d.id} value={d.id}>
                    {d.id}
                  </Select.Option>
                ))}
              </Select>
              <Label>Inverter Id :</Label>
              <Select
                value={data.inverterIds}
                onChange={inverterIds => setData({ ...data, inverterIds })}
                style={{ gridColumnEnd: 'span 3' }}
                mode="multiple"
                allowClear
              >
                <Select.Option key="ALL" value="ALL">
                  ALL
                </Select.Option>
                {inverterIdBYPlant.map(({ inverterId }) => (
                  <Select.Option key={inverterId} value={inverterId}>
                    {inverterId}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Tabs.TabPane>
        </Tabs>
        <Divider
          style={{ gridColumnEnd: 'span 4', marginTop: 20, marginBottom: 20 }}
        />

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '100px 150px 100px 150px',
            gap: 10,
            // border: '0px solid black',
            padding: 10,
            border: '1px solid #d9d9d9',
          }}
        >
          <Label>Cause Code :</Label>
          <InputNumber
            style={{ width: 'auto', gridColumnEnd: 'span 2' }}
            value={data.causecode}
            onChange={causecode => setData({ ...data, causecode })}
          />
          <Button
            type="primary"
            onClick={openCauseCodeDialog}
            style={{ gridColumnEnd: 'span 1', width: 'fit-content' }}
          >
            Select Cause Code
          </Button>
        </div>

        {causeCodeDialog.causeCodeDialog && (
          <MultiCauseCode
            key="multicausecodelist"
            // style={{ ...inlineStyle }}
            // checkable={false}
            visibleDialog={causeCodeDialog.causeCodeDialog}
            onDialogClose={onCauseCodeDialogClose}
            onCancelAction={onCauseCodeTreeCancel}
            defaultExpandedKeys={
              data.causecode ? causeCodeDialog.selectedKeys : []
            }
            selectedKeys={causeCodeDialog.causeCodeKeyValues}
            selectedValues={causeCodeDialog.causeCodeValues}
            // selectedValues={this.state.causeCodeValues || []}
            unitCodes={[]}
            multiple={false}
            checkable={false}
            selectable
            causeCodeValue={[data.causecode]}
            causeCodeList={causeCodeList}
          />
        )}
      </Modal>
    </div>
  )
}
